// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"91fa6107","195":"3a3781c0","365":"4ba1b9ca"}[chunkId] + ".chunk.css";
};